module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0008.6259d9ba.jpg";